<template>
    <aside id="popup-send-report-email" class="layout-popup mfp-hide">
        <h2 class="layout-popup-title">
            {{ $t('COMMON.REPORT.POPUP_TITLE') }}<!--리포트 발송-->
        </h2>
        <div class="layout-popup-contents">
            <p>{{ $t('COMMON.REPORT.POPUP_DESC') }}<!--검사 결과에 대한 리포트를 발송합니다.--></p>

            <fieldset class="forms setting-schedule">
                <legend>{{ $t('POLICY.RULE.ACTION.SELECT_RECIPIENT') }}</legend>

                <div class="vstack" :key="renderKey">
                    <div class="form-item">
                        <label for="" class="textfield-with">{{$t('COMMON.REPORT.INPUT_USER')}}<!--수신인 선택 --><span class="icon-required">{{$t('COMMON.FIELD_REQUIRE')}}</span></label>

                        <select-box-multi select-id="select-email"
                                          select-class="type-tagging search"
                                          :place-holder="$t('COMMON.REPORT.INPUT_USER')"
                                          :use-labels="true"
                                          :use-translate="false"
                                          :select-box-options="getUserListOptions"
                                          :select-box-value="getUserListOptions"
                                          @onSelectChange="selUserList= $event.value"></select-box-multi>


                    </div>

                    <div class="form-item">
                        <label class="textfield-with">{{$t('COMMON.REPORT.SELECT_LANG')}}<!--언어 선택--> <span class="icon-required">{{$t('COMMON.FIELD_REQUIRE')}}</span></label>
                        <select-box-single select-id="sel-language"
                                           select-class="type-single"
                                           :place-holder="$t('COMMON.REPORT.PLACEHOLDER_LANG')"
                                           :select-box-options="labList"
                                           :use-translate="true"
                                           @onSelectChange="selLang = $event.value"></select-box-single>
                    </div>
                </div>
            </fieldset>
        </div>

        <div class="layout-popup-footer">
            <p class="btns">
                <button type="button" class="buttons" data-size="popup"  v-on:click="closePopup()">{{$t('COMMON.BUTTON.CAMEL.CANCEL')}}</button>
                <button type="button" class="buttons" data-type="key" data-size="popup" v-on:click="sendDashboardReport()">{{$t('COMMON.BUTTON.CAMEL.OK')}}</button>
            </p>
        </div>
    </aside>
</template>

<script>

import {mapGetters} from "vuex";

export default {
    name: 'PopSendReport',
    props: {
        type: String,
        userList: {
            type: Array,
            default: ()=>[]
        }
    },
    data: function () {
        return {
            renderKey: 1,
            selUserList: [],
            labList: [{
                key: "ko", val: "한국어"
            }, {
                key: "en", val: "ENGLISH"
            }, {
                key: "ja", val: "日本語"
            }, {
                key: "zh", val: "简体中文"
            }],
            selLang: null
        }
    },
    computed: {
        ...mapGetters({
            curCmpnId: 'user/curCmpnId'
        }),
        getUserListOptions: function () {
            let ctgFilter = []
            this.userList.forEach(function (o) {
                ctgFilter.push({key: o.userId, val: o.userNm})
            });
            this.initView();
            return ctgFilter
        }
    },
    methods: {
        initView() {
            let self = this;
            $('.type-tagging').dropdown({
                onChange: function (value, text, $choice) {
                    //console.log(value, text, $choice)
                    if (value.length > 0) {
                        $('.go-vendor.type-tagging').addClass('selected');
                        self.selUserList.push({'userId': value, 'userNm': $choice})
                        //console.log(' >>>>>', self.selUserList)
                    } else {
                        $('.go-vendor.type-tagging').removeClass('selected');
                            _.remove(self.selUserList, function(o){ o.userId == value})
                    }
                },
            });
        },
        sendDashboardReport() {
            if (this.selUserList.length < 1) {
                return;
            }

            if (!this.selLang || this.selLang.length < 1) {
                return;
            }
            var url = `/api/governance/dashboard/report/send`;
            var header = {
                "cmpnId": this.curCmpnId,
                "userList": this.selUserList,
                "type": this.type,
                "cmplId": this.$route.query.cmpl ? this.$route.query.cmpl : null,
                "lang": this.selLang
            };

            this.http.post(url, JSON.stringify(header));
            this.closePopup();
        },
        closePopup() {
            // this.$refs.SearchEmailUser.closePopup();
            this.Common.closePopup();
            this.selUserList = [];
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/components/common/popSendReport.vue